export default "__VITE_ASSET__4a72de75__"